import React from "react";
import SimpleSortableTable from "../../../../components/Organismos/Table/SimpleSortableTable";
import Button from "../../../../components/staff/Button";
import { REGISTRANT_HISTORY_COLUMNS } from "../constants";
import { useEditParticipantAudit } from "../hooks/useEditParticipantAudit";
import { selectRegistrationId } from "../editParticipant.selectors";
import { useSelector } from "react-redux";

export default function RegistrantHistorySection (): React.ReactElement {
  const registrationId = useSelector(selectRegistrationId);
  const {
    registrantHistoryRows,
    isLoadingAuditLogs,
    showLoadMoreAuditHistory,
    setAuditHistoryExpanded,
  } = useEditParticipantAudit();

  return (
    <div>
      <div className="flex items-center justify-between gap-4 mb-4">
        <h3 className="text-secondary">
          Registrant History
        </h3>
        {showLoadMoreAuditHistory && (
          <Button
            text="Load more (3 years)"
            onClick={() => setAuditHistoryExpanded(true)}
            color="secondary"
            variant="outlined"
            size="fixed"
            disabled={isLoadingAuditLogs || !registrationId}
            className="!w-fit lg:!w-auto"
          />
        )}
      </div>
      <SimpleSortableTable
        columns={REGISTRANT_HISTORY_COLUMNS}
        data={registrantHistoryRows}
        emptyMessage={
          isLoadingAuditLogs
            ? "Loading history..."
            : "No registrant history yet"
        }
        defaultSorting={{ field: "index", order: "asc" }}
      />
    </div>
  );
}
